import { format, parse } from 'date-fns'
import { API_DATE_MASK, DATE_MASK } from './constants'

export const convertBirthDate = (birthDate: string | Date) => format(new Date(birthDate), DATE_MASK)

export const convertBirthDateToApi = (date: string) => format(parse(date, DATE_MASK, new Date()), API_DATE_MASK)

export const getPreparedMask = (pattern: string) => DATE_MASK.replace(/[A-Za-z]/g, pattern)

export const calculateAge = (birthday: Date): number => {
  const ageDifMs = Date.now() - birthday.getTime()

  if (ageDifMs > 0) {
    const ageDate = new Date(ageDifMs)

    return Math.abs(ageDate.getUTCFullYear() - 1970)
  }

  return -1
}
